import React from 'react';

import { useSelector } from 'react-redux';

import { Alert } from 'wanderu-components';
import { tripSummarySelectors } from 'wanderu-ducks-search';
import { i18nMoney as ourMoney, localize } from 'wanderu-i18n';

import { useCarrierDataSelector, useMismatchedCurrencySelector, usePricesSelector } from '../hooks';

import type { TFunction } from 'i18next';

interface CurrencyMismatchProps {
    i18nMoney: typeof ourMoney;
    t: TFunction;
    tripId: string;
}

const CurrencyMismatch = ({
    i18nMoney,
    t,
    tripId,
}: CurrencyMismatchProps) => {
    const showCurrencyMismatch = useMismatchedCurrencySelector(tripId);

    const {
        seats = 0,
        wheelchairs = 0,
    } = useSelector(tripSummarySelectors.selectTravelerInfo);

    const prices = usePricesSelector({
        seats,
        showTotalPrice: true,
        tripIds: [tripId],
        wheelchairs,
    });

    const price = prices[0];

    let tripPrice: number | undefined;
    let tripCurrency: string | undefined;

    if (price) {
        tripCurrency = Object.keys(price)[0];
        tripPrice = price[tripCurrency];
    }

    const carrierData = useCarrierDataSelector(tripId);

    const originalPrice = i18nMoney(tripPrice, tripCurrency).setCurrency(tripCurrency).format();
    const convertedPrice = i18nMoney(tripPrice, tripCurrency).format();

    return (showCurrencyMismatch && tripPrice !== undefined && tripCurrency) && (
        <Alert variant="info">
            {t('currency-conversion', {
                carriers: carrierData?.name,
                convertedPrice,
                originalPrice,
            })}
        </Alert>
    );
};

export default localize(CurrencyMismatch, ['i18nMoney', 't'], 'baseApp');
